import { Container, Grid } from "@mui/material"
import BackButton from "components/BackButton"
import useDispatch from "hooks/useDispatch"
import FutureTable from "pages/Broker/components/FutureTable"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { getBrokerInfoDetail } from "store/slices/wallet/walletSlice"
import SpotTable from "./components/SpotTable"
import TableSkeleton from "components/Skeletons/Table.skeleton"

function Broker() {
  const dispatch = useDispatch()
  const { brokerId } = useParams()

  const brokerInfoDetail = useSelector((state) => state.wallet.brokerInfoDetail?.data)

  const [loading, setLoading] = useState(false)

  const handleGetBrokerInfoDetail = async () => {
    setLoading(true)

    await dispatch(getBrokerInfoDetail({ brokerId }))

    setLoading(false)
  }

  useEffect(() => {
    handleGetBrokerInfoDetail()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Container maxWidth="100%">
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <BackButton to={`/trade/1/3?brokerId=${brokerId}`} text="Broker Information" />
        </Grid>

        {
          loading ?
            <TableSkeleton />
            :
            <Grid item xs={12}>
              {
                brokerInfoDetail?.isHaveFuture &&
                <FutureTable brokerInfoDetail={brokerInfoDetail} />
              }

              {
                brokerInfoDetail?.isHaveSpot &&
                <SpotTable brokerInfoDetail={brokerInfoDetail} />
              }
            </Grid>
        }
      </Grid>
    </Container>
  )
}

export default Broker